import { controlDeferred } from '@eureka/utils/control';
import { computed } from 'vue';
import { checkJpEnv } from '@eureka/utils/check-jp-env';
import { computedAsync } from '@vueuse/core';

export const usePlg = () => {
    // 判断是否为 LsPLG 用户，模板中判断
    const isLsPlg = computedAsync(async() => {
        const control = await controlDeferred.promise;
        return control.isLsPlg;
    });

    // 获取 PLG 用户角色，模板中判断
    const lsPlgRole = computedAsync(() => {
        return controlDeferred.promise.then(control => control.ls_plg_role);
    });

    // 判断是否为 PLG 基础版用户
    const isPlgBasic = computed(() => {
        return lsPlgRole.value === 'personal_basic';
    });

    // 判断是否为 LsPLG 用户
    const checkIsLsPlg = async function() {
        return (await controlDeferred.promise).isLsPlg;
    };

    // 获取 PLG 用户角色
    const getLsPlgRole = async function() {
        return (await controlDeferred.promise).ls_plg_role;
    };

    // 判断是否为 PLG 基础版用户
    const checkIsPlgBasic = async function() {
        return (await getLsPlgRole()) === 'personal_basic';
    };

    const isJPEnv = computed(() => {
        return checkJpEnv();
    })

    return {
        isLsPlg,
        lsPlgRole,
        isPlgBasic,
        checkIsLsPlg,
        getLsPlgRole,
        checkIsPlgBasic,
        isJPEnv,
    }
}
